import { Sector } from '../../model/sector';

export function stringToSector(sector: string): Sector {
  switch (sector) {
    case 'transport':
      return Sector.Transport;
    case 'industry':
      return Sector.Industry;
    case 'agriculture':
      return Sector.Agriculture;
    case 'energy':
      return Sector.Energy;
    case 'other':
      return Sector.Other;
    default:
      return Sector.None;
  }
}
